
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import Swal from 'sweetalert2'
import { getProperty } from './objectUtils'
import { currencyFormatter } from './formatter'

//  TODO: estilos possiveis das colunas
//  para definir o estilo da coluna, basta adicionar o atributo style seguindo o padrão abaixo
//  styleReport: {atributo: valor, atributo: valor, ...}
//  atributos possiveis:
//  font: helvetica|times|courier = helvetica
//  fontStyle: normal|bold|italic|bolditalic = normal
//  overflow: linebreak|ellipsize|visible|hidden = linebreak
//  fillColor: Color? = null
//  textColor: Color? = 20
//  cellWidth: auto|wrap|number = auto
//  minCellWidth: number? = 10
//  minCellHeight: number = 0
//  halign: left|center|right = left
//  valign: top|middle|bottom = top
//  fontSize: number = 10
//  cellPadding: Padding = 10
//  lineColor: Color = 10
//  lineWidth: border = 0
//  mesAno: boolean = false
//  type: number|integer|mesAno|array = null
//  alterValue: {valor: valor, valor: valor, ...} = null
//  sum: boolean = false

const dateNow = new Date().toLocaleDateString('pt-BR', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})
const horaNow = new Date().toLocaleTimeString('pt-BR', {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
})

const dataPermitidas = [
  'YYYY-MM-DD HH:mm:ss',
  'DD/MM/YYYY HH:mm:ss',
  'YYYY-MM-DD',
  'YYYY-MM-DDTHH:mm:ss.SSSSSSZ',
]

function addHeader (doc, name, logo) {
  const docWidth = doc.internal.pageSize.width

  doc.addImage(logo, 'png', 10, 5, 38, 14)
  doc.setFontSize(16)
  doc.text(name, docWidth / 2, 15, { align: 'center' })
  doc.setFontSize(8)
  doc.text(dateNow, docWidth - 10, (15), { align: 'right' })
  doc.text(horaNow, docWidth - 10, (20), { align: 'right' })
  doc.line(5, (24), docWidth - 5, (24))
}

function addFooter (pageNumber, doc, totalPages) {
  const docWidth = doc.internal.pageSize.width
  const docHeight = doc.internal.pageSize.height

  doc.setFontSize(7)
  doc.text(dateNow, 10 - 5, docHeight - 10)
  doc.text('https://app.pioneiros.vet.br', docWidth / 2, docHeight - 10, { align: 'center' })
  doc.text('Página ' + pageNumber + ' / ' + totalPages, docWidth + 17, docHeight - 10, { align: 'right' })
}

function mesAnoFormatter (value) {
  return moment(value).format('MM/YYYY')
}

function creatHeader (headers) {
  let miniHeader = false

  const styles = {}
  const headersFiltered = headers.filter(header => header.report).map(header => {
    styles[header.value] = {}
    if (header.styleReport) {
      styles[header.value] = header.styleReport
    }
    if (header.alterValue) {
      styles[header.value].alterValue = header.alterValue
    }
    if (header.rename) {
      header.text = header.rename
    }
    if (header.report === 'mini') {
      miniHeader = true
    }
    return { dataKey: header.value, header: header.text, sum: header.sum || false }
  })
  return [headersFiltered, styles, miniHeader]
}

function createRows (data, headers, styles) {
  const sum = {}
  const rows = data.map(item => {
    const row = {}
    headers.forEach(header => {
      if (header.sum) {
        sum[header.dataKey] = (sum[header.dataKey] || 0) + Number(getProperty(item, header.dataKey))
      }
      const headerValue = applyHeaderStyle(header, item, styles)
      row[header.dataKey] = headerValue
    })
    return row
  })
  return [rows, sum]
}

function applyHeaderStyle (header, item, styles) {
  const value = getProperty(item, header.dataKey)
  const style = styles[header.dataKey]
  if (style) {
    if (style.alterValue) {
      const alterValue = style.alterValue
      return alterValue[value] || value
    }
    switch (style.type) {
      case 'number':
        return currencyFormatter(value)
      case 'integer':
        return currencyFormatter(value, 0)
      case 'mesAno':
        return mesAnoFormatter(value)
      case 'array':
        return value.join(',/n')
    }
  }
  if (moment(value, dataPermitidas, true).isValid()) {
    return moment(value).format('DD/MM/YYYY')
  }
  return value
}

async function loadImageAsBase64 (url) {
  const response = await fetch(url)
  const blob = await response.blob()

  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

export const JsonToPdf = async (data, headers, name) => {
  if (data.length > 200) {
    await new Promise((resolve) => {
      Swal.fire({
        title: 'Gerando PDF...',
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading()
          requestAnimationFrame(resolve)
        },
      })
    })
    await new Promise(resolve => requestAnimationFrame(resolve))
  }

  const logo = await loadImageAsBase64(window.location.origin + '/img/logo.png')

  const [cols, styles, miniHeader] = creatHeader(headers)
  const [rows, sum] = createRows(data, cols, styles)
  // eslint-disable-next-line new-cap
  var doc = new jsPDF({
    orientation: 'landscape',
  })
  if (Object.keys(sum).length) {
    const keyInicial = cols[0].dataKey

    cols.forEach(col => {
      if (sum[col.dataKey]) {
        sum[col.dataKey] = { content: currencyFormatter(sum[col.dataKey]), styles: { fontStyle: 'bold', textColor: '#003677' } }
      } else {
        sum[col.dataKey] = { content: '', styles: { fontStyle: 'bold', textColor: '#003677' } }
      }
    })
    sum[keyInicial] = { content: 'Total', styles: { fontStyle: 'bold', textColor: '#003677', halign: 'left' } }

    rows.push(sum)
  }
  let startY = 27

  var totalPages = '{total_pages_count_string}'

  doc.autoTable({
    theme: 'plain',
    columnStyles: styles,
    headStyles: {
      textColor: '#FFFFFF',
      fillColor: '#1E88E5',
      fontSize: miniHeader ? 7 : 10,
    },
    styles: {
      fontSize: miniHeader ? 7 : 10,
    },
    columns: cols,
    body: rows,
    startY: startY,
    pageBreak: 'auto',
    margin: { left: 5, top: 27, bottom: 15, right: 5 },
    didDrawPage: (data) => {
      addHeader(doc, name, logo)
      addFooter(data.pageNumber, doc, totalPages)
    },
  })
  startY = doc.autoTable.previous.finalY

  if (typeof doc.putTotalPages === 'function') {
    doc.putTotalPages(totalPages)
  }
  Swal.close()
  doc.save(name + '.pdf')
}
